import { FormattedMessage, useIntl } from "react-intl";
import { Navigate, useParams } from "react-router";
import { BackButton } from "@/components/common/BackButton";
import { useHasFeature } from "@/auth/access-features";
import { FEATURE_CATALOG } from "@/auth/feature-catalog";
import { ShareDetailStatus } from "@/components/share/ShareDetailStatus";
import { ListingState } from "@/graphql/generated/operations";
import { ListingPostView } from "./ListingPostView";
import { useListing } from "./use-listing";

// Der "Post" einer Ausschreibung aus ihrem Dashboard heraus (/share/listings/:listingId/post): so,
// wie Bewerbende sie lesen, aber über `listing(id)`, also für Mitglieder in jedem Zustand. Solange sie
// nicht offen ist, sagt ein Hinweis, dass das eine Vorschau ist: `openListing` beantwortet genesis
// Bewerbenden erst ab OPEN.
export function ListingPostPage() {
  const intl = useIntl();
  const { listingId = "" } = useParams();
  const { listing, loading, error } = useListing(listingId);
  const canApply = useHasFeature(FEATURE_CATALOG.shareApplications.key);

  if (canApply && !loading && !error && listing && listing.access == null) {
    return <Navigate to={`/share/open-listings/${listing.id}`} replace />;
  }

  return (
    <main className="w-full max-w-[1600px] px-4 pb-12 pt-6 @sm:px-6 @lg:px-10" data-graphql="Listing">
      <div className="mb-5">
        <BackButton />
      </div>
      {loading || error || !listing ? (
        <ShareDetailStatus
          loading={loading}
          error={error}
          notFoundLabel={intl.formatMessage({
            id: "share.listings.notFound",
            defaultMessage: "Ausschreibung nicht gefunden",
          })}
        />
      ) : (
        <>
          {listing.state !== ListingState.Open ? (
            <div id="listing-post-preview" className="smycles-hint mb-6">
              <div className="text-smycles-micro tracking-[0.2em] text-ink-accent">
                <FormattedMessage id="share.listings.post.previewLabel" defaultMessage="Vorschau" />
              </div>
              <div className="mt-1 smycles-field-value text-ink">
                <FormattedMessage
                  id="share.listings.post.previewHint"
                  defaultMessage="Bewerbende sehen das erst, wenn die Ausschreibung offen ist."
                />
              </div>
            </div>
          ) : null}
          <ListingPostView listing={listing} />
        </>
      )}
    </main>
  );
}
